/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
/* with parameterised scrollContainer mod by Bob Gear

infinite-scroll-container - text parameter for id of container inside which the content will scroll

*/
var mod;

mod = angular.module('infinite-scroll', []);

mod.directive('infiniteScroll', [
  '$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
    return {
      link: function (scope, elem, attrs) {

        var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
        var scrollContainer = $("#" + attrs.infiniteScrollContainer);

        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function (value) {
            return scrollDistance = parseInt(value, 10);
          });
        }
        scrollEnabled = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function (value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          });
        }


        scope.$watch(attrs.infiniteScrollContentCount, function () {
          fetchIfGap();
        });

        var fetchIfGap =  function(){
          var elementBottom, scrollContainerBottom;
          scrollContainerBottom = scrollContainer.height() + scrollContainer.scrollTop();
          elementBottom = elem.offset().top + elem.height();
          var gap = scrollContainerBottom - elementBottom;

          if (gap > 0)
          {
            return handler();
          }
        };



        handler = function () {
          var elementBottom, remaining, shouldScroll, windowBottom;
          windowBottom = scrollContainer.height() + scrollContainer.scrollTop();
          elementBottom = elem.offset().top + elem.height();
          remaining = elementBottom - windowBottom;
          shouldScroll = remaining <= scrollContainer.height() * scrollDistance;
          
          if (shouldScroll && scrollEnabled) {
            if ($rootScope.$$phase) {
              return scope.$eval(attrs.infiniteScroll);
            } else {
              return scope.$apply(attrs.infiniteScroll);
            }
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };

        ///******************************************************
        // * cope with window resizing  to  determine if a page
        // * load is needed
        // * ****************************************************/
        ////var win = angular.element($window);
        ////win.bind("resize",function(e){
        ////
        ////  fetchIfGap();
        ////
        ////})
        //
        //scope.getElementOffsetTop = function () {
        //  return scrollContainer.height();
        //};
        //scope.$watch(scope.getElementOffsetTop, function(){
        //    fetchIfGap();
        //  });
        ///*******************************************************/

        scrollContainer.on('scroll', handler);

        scope.$on('$destroy', function () {
          return scrollContainer.off('scroll', handler);
        });

        return $timeout((function () {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          }
          else {
            return handler();
          }
        }), 0);
      }
    };
  }
]);